import { Link } from "react-router-dom";
import { Home, Phone, Mail, MapPin, Check } from "lucide-react";
import { BRAND } from "../../lib/api";
import { VeteranApplyForm } from "./VeteranApplyForm";
import { BetheaProgress } from "./BetheaProgress";
import { DonorWall } from "./DonorWall";

const FLYER = "https://customer-assets-eiarnc6j.emergentagent.net/job_pastor-shalonda/artifacts/5ce2345ab8e12a6e_6B2727C3-5AEB-441D-864F-DE381758AA6D.PNG";
const OFFERS = [
  "Safe & comfortable shared housing",
  "Affordable monthly living options",
  "Supportive, faith-filled community",
  "Veteran-focused resources & referrals",
  "Close access to local VA services",
];

export const VeteranHousing = () => (
  <section id="veteran-housing" data-testid="veteran-housing-section" className="container-narrow py-20">
    <div className="grid lg:grid-cols-12 gap-10 items-center">
      <div className="lg:col-span-5">
        <a href={FLYER} target="_blank" rel="noreferrer" data-testid="veteran-flyer-link">
          <img src={FLYER} alt="House of Bethea veteran housing flyer" data-testid="veteran-flyer-img"
            className="w-full rounded-3xl shadow-2xl ring-2 ring-[#D4AF37]/50 hover:scale-[1.02] transition-transform duration-300" />
        </a>
      </div>
      <div className="lg:col-span-7">
        <div className="label-luxe flex items-center gap-2"><Home className="w-4 h-4" /> Veteran Housing</div>
        <h2 className="font-serif text-4xl mt-2">House of Bethea</h2>
        <p className="text-[#D4AF37] font-serif italic text-lg mt-2">Serving Those Who Served Us.</p>
        <p className="mt-5 text-white leading-relaxed">
          A safe place for veterans to live, heal, and rebuild. House of Bethea provides a respectful, structured,
          and supportive home for veterans transitioning into stability and independence — rooted in honor, dignity, and community.
          Limited space is available.
        </p>
        <ul className="mt-6 grid sm:grid-cols-2 gap-3">
          {OFFERS.map((o) => (
            <li key={o} className="flex items-start gap-2 text-sm text-white">
              <Check className="w-4 h-4 mt-0.5 text-[#D4AF37] shrink-0" /> {o}
            </li>
          ))}
        </ul>
        <div className="mt-6 card-luxe !p-5 text-sm space-y-2" data-testid="veteran-contact">
          <div className="font-semibold">Contact Pastor Shalonda Raymond or Minister Jennifer Ward</div>
          <div className="flex items-center gap-2"><Phone className="w-4 h-4 text-[#D4AF37]" /> {BRAND.phone}</div>
          <div className="flex items-center gap-2 break-all"><Mail className="w-4 h-4 text-[#D4AF37] shrink-0" /> {BRAND.email}</div>
          <div className="flex items-center gap-2"><MapPin className="w-4 h-4 text-[#D4AF37]" /> {BRAND.city}</div>
        </div>
        <BetheaProgress />
        <DonorWall />
        <div className="mt-6 flex flex-wrap gap-3">
          <a href="#veteran-apply" data-testid="veteran-apply-btn" className="btn-fuchsia">Apply Online</a>
          <a href={`tel:${BRAND.phone.replace(/\D/g, "")}`} data-testid="veteran-call-btn" className="btn-fuchsia">Call Us</a>
          <a href={`mailto:${BRAND.email}?subject=Veteran%20Housing%20Inquiry`} data-testid="veteran-email-btn" className="btn-fuchsia">Email Us</a>
          <Link to="/give?fund=bethea" data-testid="veteran-donate-btn" className="btn-fuchsia">Donate to House of Bethea</Link>
        </div>
      </div>
    </div>
    <div className="mt-12 max-w-3xl mx-auto"><VeteranApplyForm /></div>
  </section>
);
